var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_766_18460)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.2499 6.54156C13.7792 6.54156 14.2083 6.97062 14.2083 7.49989C14.2083 8.02916 13.7792 8.45822 13.2499 8.45822H1.7499C1.2206 8.45822 0.7916 8.02916 0.7916 7.49989C0.7916 6.97062 1.2206 6.54156 1.7499 6.54156H13.2499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17769 12.5723C8.55194 12.9465 8.55194 13.5533 8.17769 13.9276C7.80343 14.3018 7.19665 14.3018 6.8224 13.9276L1.07236 8.17755C0.709557 7.81475 0.696857 7.23056 1.04356 6.85234L6.31443 1.10234C6.67208 0.712178 7.27829 0.685821 7.66844 1.04347C8.0586 1.40111 8.08496 2.00732 7.72731 2.39748L3.07646 7.47109L8.17769 12.5723Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_766_18460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "matrix(-1 0 0 1 15 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.88645589469b8dc86611c952aaa546b6.svg";
export { ForwardRef as ReactComponent };